import { NumericValueAccessor } from '@ionic/angular';

export class Page {
    title: string;
    url: string;
    icon: string;
    isVisible?: boolean;
    forDesktop?: boolean;
    child: PageChild[];
    lowPriority?: boolean;
  };
export class PageChild {
    title: string;
    url: string;
};